import React from "react";

/**
 * MidStrip — section divider that runs a thin announcement marquee
 * between major sections to add motion + reinforce the dot motif.
 */
const items = [
    "Strategy",
    "Content",
    "Influencers",
    "Brand",
    "Production",
    "Reels",
    "Performance",
];

const MidStrip = ({ tone = "light" }) => {
    const dark = tone === "dark";
    return (
        <div
            data-testid="mid-strip"
            className={`overflow-hidden border-y ${
                dark ? "bg-[#0A0A0A] text-white border-white/15" : "bg-white text-black border-black/15"
            } py-3`}
        >
            <div className="marquee-track">
                {Array.from({ length: 6 }).map((_, k) => (
                    <span key={k} className="flex items-center gap-6 px-4 text-[12px] tracking-[0.28em] uppercase font-bold">
                        {items.map((it) => (
                            <span key={`${k}-${it}`} className="flex items-center gap-6">
                                {it}
                                <span className="w-1.5 h-1.5 rounded-full bg-[#E60000]" />
                            </span>
                        ))}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default MidStrip;
